<template>
  <section v-loading="loading" :element-loading-text="'Loading icons list, please wait...'">
    <div class="total-container">
      <div class="searchbar-wrapper flex items-center justify-between" id="iconListCardSearch">
        <div class="flex items-center !gap-2">
          <el-switch
            class="ml-1"
            active-color="var(--brand-500)"
            inactive-color="var(--black-200)"
            v-model="currentIconType"
            active-text="FILL"
            inactive-text="OUTLINE"
            active-value="FILL"
            inactive-value="OUTLINE"
          ></el-switch>
          <el-input
            type="text"
            v-model="searchQuery"
            placeholder="Search icons..."
            class="search-bar relative min-w-96"
            clearable
          >
            <template #prefix>
              <i class="el-icon-search"></i>
            </template>
          </el-input>
        </div>

        <el-select
          v-model="currentCategory"
          placeholder="Select Category"
          class="category-select"
          clearable
        >
          <el-option label="ALL" value="DEFAULT"></el-option>
          <el-option label="EDUCATION" value="EDUCATION"></el-option>
          <el-option label="SOCIAL MEDIA" value="SOCIAL MEDIA"></el-option>
          <el-option label="HOSPITAL" value="HOSPITAL"></el-option>
          <el-option label="TRANSPORT" value="TRANSPORT"></el-option>
          <el-option label="HUMAN RESOURCES" value="HUMAN RESOURCES"></el-option>
        </el-select>
      </div>
      <div class="iconslist-container">
        <div v-for="icon in filteredIcons" :key="icon.key">
          <IconsV2 v-if="!iconsFromLocal" :icon="icon" :key="icon.key" @icon-click="sendIconData" />
          <div v-else class="custom-icon-wrapper">
            <div @click.prevent="sendIconData(icon.key)">
              <div
                v-html="cleanedSvg(icon.content)"
                class="centered-content custom-icon icon3"
              ></div>
              <el-tooltip v-if="(icon.name || '').length > 15" :content="icon.name" placement="top">
                <div class="centered-content truncated-name">
                  {{ (icon.name || '').slice(0, 15) + '...' }}
                </div>
              </el-tooltip>
              <div v-else class="centered-content">{{ icon.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import IconsV2 from './IconsV2.vue';
  import { fetchAllIconsFromLocal, fetchSvgContentFromS3, addIconsToLocal } from '@/repo/iconsRepo';
  import { mapGetters } from 'vuex';

  export default {
    name: 'IconsList',
    components: {
      IconsV2,
    },
    data() {
      return {
        menuIcons: [],
        localIcons: [],
        searchQuery: '',
        currentIconType: 'FILL',
        currentCategory: 'DEFAULT',
        loading: false,
        iconsFromLocal: false,
      };
    },
    async mounted() {
      this.loading = true;
      await this.fetchIcons();
    },
    methods: {
      async fetchIcons() {
        try {
          this.localIcons = await fetchAllIconsFromLocal();
          if (this.localIcons.length) {
            let apiIcons = this.getApiIcons;
            const existingKeys = new Set(this.localIcons.map((icon) => icon.key));
            const newIcons = apiIcons.filter((icon) => !existingKeys.has(icon.key));
            if (newIcons.length) {
              await this.preloadAndCacheAllIcons(newIcons);
            }
            this.menuIcons = await fetchAllIconsFromLocal();
            this.iconsFromLocal = true;
          } else {
            let apiIcons = this.getApiIcons;
            await this.preloadAndCacheAllIcons(apiIcons);
            this.menuIcons = await fetchAllIconsFromLocal();
            this.iconsFromLocal = true;
          }
        } catch (err) {
          console.error('Error while loading icons:', err);
        } finally {
          this.loading = false;
        }
      },
      async preloadAndCacheAllIcons(apiIcons) {
        const keys = apiIcons.map((icon) => icon.key);
        const svgIcons = await fetchSvgContentFromS3(keys);
        const enrichedIcons = apiIcons.map((icon) => {
          const matched = svgIcons.find((svg) => svg.name === icon.key);
          return {
            ...icon,
            content: matched?.content || '',
          };
        });
        await addIconsToLocal(enrichedIcons);
      },
      sendIconData(iconName) {
        this.$emit('icon-data', iconName);
      },
      cleanedSvg(rawSvg) {
        return rawSvg?.replace(/\\n/g, '').replace(/\\"/g, '"').replace(/\\\\/g, '');
      },
    },
    computed: {
      ...mapGetters('icons', ['getApiIcons']),
      filteredIcons() {
        const query = this.searchQuery.toLowerCase();
        return this.menuIcons.filter((icon) => {
          const matchesCategory =
            this.currentCategory === 'DEFAULT' || icon.category === this.currentCategory;
          const matchesType = icon.type === this.currentIconType;
          const matchesQuery =
            (icon.key || '').toLowerCase().includes(query) ||
            (icon.name || '').toLowerCase().includes(query);
          return matchesCategory && matchesType && matchesQuery;
        });
      },
    },
  };
</script>

<style scoped>
  .searchbar-wrapper {
    display: flex;
  }

  .total-container {
    margin-bottom: 20px;
  }

  /* .category-select {
  margin-left: 420px;
} */
  .search-bar {
    width: 30%;
    padding: 10px;
    /* margin-bottom: 20px; */
    font-size: 16px;
  }

  .search-bar ::v-deep .el-input__suffix {
    top: 3px;
    right: 12px !important;
  }

  .search-bar .el-input__prefix {
    top: 16px !important;
    right: 16px !important;
  }

  .iconslist-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    grid-gap: 40px;
    justify-content: center;
    align-items: center;
    max-height: calc(100vh - 370px);
    padding: 20px 0px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .el-icon-search {
    /* margin-top: 18px; */
    margin-left: 15px;
  }

  .custom-icon-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .centered-content {
    display: flex;
    margin-top: 5px;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .el-icon-search {
    margin-left: 15px;
  }
</style>

<style lang="scss">
  .icon3 {
    .primary {
      fill: var(--primary-color-brand) !important;
    }

    .stroke {
      stroke: var(--primary-color-brand);
      fill: #fff !important;
    }
  }
</style>
